import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_MultiStationVisiteeMaintenance } from "../../shared/data.service";

@Component({
	selector: "app-ms-visitee-batch-import",
	templateUrl: "./ms-visitee-batch-import.component.html",
	styleUrls: ["./ms-visitee-batch-import.component.css"],
})
export class MsVisiteeBatchImportComponent implements OnInit {
	constructor(private visitorService: DataService_MultiStationVisiteeMaintenance, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		this.loadFormatOptions();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	LoadingOptions: any = true;
	IsProcessing: any = false;

	FormatOption: any;
	lstFormatOptions: any = [];

	ImportFile: any; //Data, ex. ImportFile.name
	ImportData: any = ""; //Base 64

	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadFormatOptions() {
		this.LoadingOptions = true;

		var result = this.visitorService.ExportFormatOptionSelectList();
		result.subscribe(
			(response) => {
				this.LoadingOptions = false;

				this.lstFormatOptions = response;

				for (var z = 0; z < this.lstFormatOptions.length; z++) {
					var next = this.lstFormatOptions[z];

					if (next.Selected == true) {
						this.FormatOption = next;
						break;
					}
				}
			},
			(error) => {
				this.LoadingOptions = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////
	onSelectFile() {
		this.errorMessage = "";

		document.getElementById("ImportInput").click();
	}

	onImport() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		//No Data
		if (this.ImportData == "") {
			this.errorMessage = "Select a file to import";
			return;
		}

		//Bad Format
		if (String(this.ImportFile.type) != "text/plain" && String(this.ImportFile.type) != "text/csv") {
			this.errorMessage = "Invalid format";
			return;
		}

		//Finish and pass the data back to main
		var lstData: any = [];
		lstData = [...lstData, this.FormatOption]; //0
		lstData = [...lstData, this.ImportData]; //1

		this.ref.close(lstData);
	}

	onClose() {
		this.errorMessage = "";

		this.ref.close("close");
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////

	onFileToImportChange(val) {
		this.IsProcessing = true;

		this.ImportFile = val.target.files[0];

		var fr = new FileReader();
		fr.readAsDataURL(this.ImportFile);

		fr.onload = () => {
			this.FinishLoadFile(fr.result);

			this.IsProcessing = false;
		};
	}

	FinishLoadFile(f) {
		this.ImportData = f;
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingOptions == true || this.IsProcessing == true;
	}

	/////////////////////////////////////////////////////////////////////
}
